
import React from "react";
import { Smile, Heart, ThumbsUp, ThumbsDown, Star, Laugh } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

interface EmojiPickerProps {
  showEmojiPicker: boolean;
  setShowEmojiPicker: (show: boolean) => void;
  addEmoji: (emoji: string) => void;
}

export const emojis = [
  { icon: <Smile size={20} />, value: "😊" },
  { icon: <Heart size={20} />, value: "❤️" },
  { icon: <ThumbsUp size={20} />, value: "👍" },
  { icon: <ThumbsDown size={20} />, value: "👎" },
  { icon: <Laugh size={20} />, value: "😂" },
  { icon: <Star size={20} />, value: "⭐" },
];

export const EmojiPicker: React.FC<EmojiPickerProps> = ({
  showEmojiPicker,
  setShowEmojiPicker,
  addEmoji,
}) => {
  return (
    <Popover open={showEmojiPicker} onOpenChange={setShowEmojiPicker}>
      <PopoverTrigger asChild>
        <Button variant="outline" size="icon" className="h-10 w-10">
          <Smile className="h-5 w-5 text-gray-500" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-64 p-2" side="top" align="end">
        <div className="grid grid-cols-6 gap-2">
          {emojis.map((emoji, index) => (
            <Button
              key={index}
              variant="ghost"
              className="h-11 w-11 sm:h-10 sm:w-10 p-0"
              onClick={() => {
                addEmoji(emoji.value);
                setShowEmojiPicker(false);
              }}
            >
              {emoji.value}
            </Button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
